import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { withTipiCombustibile } from "../withTipiCombustibile";
import { formGroup } from "../../common/components/formGroup";

const DropdownList = Dropdown<string>();
interface Props {
    data: string[],
    value: string | null,
    onChange: (type: string | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __TipoCombustibileSelector extends React.PureComponent<Props>{

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label ?? "Nome configurazione"}
            allowNull
            data={data}
            textField={x => x}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export const TipoCombustibileSelector = formGroup(withTipiCombustibile(__TipoCombustibileSelector)(x => x.getall(), "data"))

